import React, { useState } from "react";
import { Loader2 } from "lucide-react";

interface CopyTradeSubscriptionSettingsFormProps {
  fixedUsdAmount: number;
  takeProfitPercent?: number | null;
  stopLossPercent?: number | null;
  isSaving?: boolean;
  onCancel: () => void;
  onSave: (payload: {
    fixedUsdAmount: number;
    takeProfitPercent?: number | null;
    stopLossPercent?: number | null;
  }) => Promise<void>;
}

export const CopyTradeSubscriptionSettingsForm: React.FC<
  CopyTradeSubscriptionSettingsFormProps
> = ({
  fixedUsdAmount,
  takeProfitPercent,
  stopLossPercent,
  isSaving,
  onCancel,
  onSave,
}) => {
  const [amount, setAmount] = useState(fixedUsdAmount);
  const [tp, setTp] = useState(
    takeProfitPercent !== null && takeProfitPercent !== undefined
      ? String(takeProfitPercent)
      : ""
  );
  const [sl, setSl] = useState(
    stopLossPercent !== null && stopLossPercent !== undefined
      ? String(stopLossPercent)
      : ""
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSave({
      fixedUsdAmount: amount,
      takeProfitPercent: tp ? Number(tp) : null,
      stopLossPercent: sl ? Number(sl) : null,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3 border-t border-border pt-4">
      <div className="space-y-2">
        <p className="text-xs uppercase tracking-wide text-text-secondary">
          Fixed margin (USDT)
        </p>
        <input
          type="number"
          min={1}
          required
          className="w-full bg-primary/40 border border-gray-700 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-accent"
          value={amount}
          onChange={(e) => setAmount(Number(e.target.value) || 1)}
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wide text-text-secondary">
            Take Profit %
          </p>
          <input
            type="number"
            min={0}
            step="0.1"
            className="w-full bg-primary/40 border border-gray-700 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-accent"
            value={tp}
            onChange={(e) => setTp(e.target.value)}
            placeholder="Optional"
          />
        </div>
        <div className="space-y-2">
          <p className="text-xs uppercase tracking-wide text-text-secondary">
            Stop Loss %
          </p>
          <input
            type="number"
            min={0}
            step="0.1"
            className="w-full bg-primary/40 border border-gray-700 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-accent"
            value={sl}
            onChange={(e) => setSl(e.target.value)}
            placeholder="Optional"
          />
        </div>
      </div>
      <div className="flex gap-2 justify-end">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 rounded-xl border border-border text-sm"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isSaving}
          className="px-4 py-2 rounded-xl bg-accent text-white text-sm font-medium disabled:opacity-50 flex items-center gap-2"
        >
          {isSaving && <Loader2 className="w-4 h-4 animate-spin" />}
          Save
        </button>
      </div>
    </form>
  );
};
